export default {
  EbikeDisplayDescriptionIcon: () =>
    import(
      /* webpackChunkName: "EbikeDisplayDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/EbikeDisplayDescriptionIcon.vue'
    ),
  EbikeMotorDescriptionIcon: () =>
    import(
      /* webpackChunkName: "EbikeMotorDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/EbikeMotorDescriptionIcon.vue'
    ),
  EbikeEngineModelIcon: () =>
    import(
      /* webpackChunkName: "EbikeEngineModelIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/EbikeEngineModelIcon.vue'
    ),
  EbikeSystemBrandIcon: () =>
    import(
      /* webpackChunkName: "EbikeSystemBrandIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/EbikeSystemBrandIcon.vue'
    ),
}
